<template>
    <card>
       <template slot="header">
          <h3 class="card-title">Office Responsibilities Record</h3>
       </template>
       <div class="row">
          <div class=" col-md-6">
            <nav class="row">
                <ol class="breadcrumb arr-right bg-breadcrum">
                   <li class="breadcrumb-item">
                      <router-link to="/hr/dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                   </li>
                   <li class="breadcrumb-item active">Office Responsibilities</li>
                   <li class="breadcrumb-item">
                      <router-link to="/hr/wfh/responsibility">WFH Responsibilities</router-link>
                   </li>
                </ol>
             </nav>
          </div>
          <hr style="margin-top:-10px"/>
          <div class="col-md-6">
             <router-link :to="'addresponsibilityform'" class="btn btn-primary float-right"><i class="fa fa-plus"></i> &nbsp;Encode Responsibility Manually</router-link>
          </div>
       </div>
       <hr style="margin-top:-10px"/>
       <div class="row">
          <div class="col-md-12">
             <p><i class="fa fa-search"></i> Search Employee</p>
             <input type="test" v-model="search" class="form-control" placeholder="Search..."> 
          </div>
       </div>
       <hr/>
       <div class="table-responsive ">
          <table class="table table-striped table-hover" v-loading="loading">
             <thead>
                <tr>
                   <th width="10"></th>
                   <th width="700">Employee Name</th>
                   <th width="100">Date Submitted</th>
                   <th width="100">Action</th>
                </tr>
             </thead>
             <tbody>
                <tr v-for="(emp,i) in computedResponsibility">
                   <template v-if="emp === 'no data found'">
                      <td colspan="100%"><h4>  <i class="fa fa-database"></i> Empty Records ...</h4></td>  
                   </template>
                   <template v-else>
                        <td>{{i+1}}</td>
                        <td>{{emp.full_name | capitalize}}</td>
                        <td>{{getDate(emp.created)}}</td>
                        <td>
                           <router-link :to="{name: 'view-responsibility', params: { id: emp.res_id }}" class="btn btn-xs btn-default"  v-b-tooltip.hover title="click to view full details of responsibility form"><i class="fa fa-eye"></i>View</router-link>
                           <router-link :to="{name: 'edit-responsibility-form', params: { id: emp.res_id }}" class="btn btn-xs btn-default"  v-b-tooltip.hover title="Modify Entry"><i class="fa fa-edit"></i>Update</router-link>
                           <button  class="btn btn-xs" @click = "deleteItem(emp.res_id, i)" v-b-tooltip.hover title="Delete Entry"><li class="fa fa-trash-o"></li>&nbsp;Delete</button>
                        </td>
                   </template>     
                </tr>
             </tbody>
          </table>
       </div>
       <!-- If Lost Connection on Server -->   
       <template v-if="display_indicator === 1">
          <center>
             <br/><br/>
             <img  src="/static/img/warning.png"  width="225" height="190">
             <h1>You've lost your network connection</h1>
             <h3>Check your wireless settings, or your network cable, and reload the page.</h3>
             <br/><br/>
          </center>
       </template>
    </card>
 </template>
     
    <script>
    /* eslint-disable */
    import Card from 'src/components/UIComponents/Cards/Card.vue'
    export default {
        components: {
            Card
        },
        data() {
            return {
                items: {},
                search: '',
                loading: true,
                 //Indicator
                display_indicator:''
            }
        },
        mounted: function() {
            this.get_responsibility();
        },
        methods: {
            get_responsibility() {
                axios.get('api/responsibility')
                    .then(response => {
                    this.items = response.data;
                    console.log(JSON.stringify(this.items));
                    this.display_indicator = 2;
                    this.loading = false;
                    })
                    .catch(error => {
                    console.log(error.response)
                    this.display_indicator = 1;
                    });
            },
           
            deleteItem(id, i)
               {

                  /* USING SWEET ALERT */

                     this.$swal({
                            title: 'Are you sure?',
                            text: 'You can\'t revert your action',
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Yes Delete it!',
                            cancelButtonText: 'No, Keep it!',
                            showCloseButton: false,
                            showLoaderOnConfirm: true
                          })
                     .then((isConfirm) => {
                          if(isConfirm === true) {
                            axios.delete('api/responsibility/delete/' + id)
                            .then(response => {                     
                                // this.items.splice(index, 1); //--> reloader 
                                 this.get_responsibility();
                                 this.$swal('Deleted', 'You successfully deleted this file', 'success')
                            })
                            .catch(response => {
                                 //alert("error");
                                  console.log(response.response);
                                  this.$swal('Error Code', 'Review your code', 'error')
                            });
                        }
                      });
                       
 
               },
        },
        computed: {
            computedResponsibility() {
                // SEARCH BY EMPLOYEE FULLNAME
                let filtered = this.items
                  if(filtered.length > 0){
                    if (this.search) {
                        filtered = filtered.filter(
                       item => item.full_name.toLowerCase().indexOf(this.search) > -1
                      );
                      return filtered
                     }
                   }
                return filtered
            }
        },

      
        }
    </script>
   


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-responsibility-form/todo-responsibility-form.vue